import { Box, Typography } from '@mui/material';
import { useAllEntities } from 'api/entity';
import { ProjectsList } from 'components/ProjectsList';
import React from 'react';

export default function ComingUp() {
  // Query for entities that have a deadline field
  const projects = useAllEntities('project');
  const tasks = useAllEntities('task');

  return (
    <Box
      sx={{
        padding: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h4" gutterBottom>
        Coming Up
      </Typography>

      <Typography
        variant="h5"
        textAlign="center"
        textTransform="uppercase"
        letterSpacing={4}
        py={4}
        borderTop="1px solid"
        borderColor="divider"
      >
        Tasks
      </Typography>
      <ProjectsList entities={tasks.data} />
      <Typography
        variant="h5"
        textAlign="center"
        textTransform="uppercase"
        letterSpacing={4}
        py={4}
        borderTop="1px solid"
        borderColor="divider"
      >
        Projects
      </Typography>
      <ProjectsList entities={projects.data} />
    </Box>
  );
}
